<script>
  // Light / dark / auto theme switcher backed by lib/theme.js (persisted in
  // localStorage, applied via data-theme on <html>). Two renderings:
  //   default — three-way segmented control (expanded sidebar footer)
  //   compact — single icon button that cycles modes (collapsed icon rail)
  import Button from './ui/button.svelte'
  import { THEME_MODES, loadTheme, setTheme } from '../lib/theme.js'

  let { compact = false } = $props()

  let theme = $state(loadTheme())

  const current = $derived(THEME_MODES.find((mode) => mode.value === theme) ?? THEME_MODES[2])

  const select = (mode) => {
    theme = mode
    setTheme(mode)
  }

  const cycle = () => {
    const index = THEME_MODES.findIndex((mode) => mode.value === theme)
    select(THEME_MODES[(index + 1) % THEME_MODES.length].value)
  }
</script>

{#if compact}
  <Button
    variant="ghost"
    size="sm"
    square
    icon={current.icon}
    title={`Theme: ${current.label} — click to switch`}
    aria-label={`Theme: ${current.label} — click to switch`}
    onclick={cycle}
  />
{:else}
  <div class="join" role="group" aria-label="Theme">
    {#each THEME_MODES as mode (mode.value)}
      <Button
        variant="ghost"
        size="sm"
        square
        icon={mode.icon}
        class={`join-item ${theme === mode.value ? 'btn-active' : ''}`}
        title={`${mode.label} theme`}
        aria-label={`${mode.label} theme`}
        aria-pressed={theme === mode.value}
        onclick={() => select(mode.value)}
      />
    {/each}
  </div>
{/if}
